<script>
import { Form, Field, Toast, Dialog } from 'vant'
import ImageUploader from '@/components/org/ImageUploader'
import PickerSelector from '@/components/org/PickerSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'
import Player from '@/tbs/model/vo/Player'

const player = new Player

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-player-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-form': Form,
        'van-field': Field,
        'image-uploader': ImageUploader,
        'picker-selector': PickerSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            player: {
                id: null,
                teamId: null,
                matchGroupId: null,
                name: null,
                logoUrl: null,
                num: null,
                gender: null
            },
            isEdit: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        submitBtnClass() {
            return {
                'van-button--disabled': !this.validateSubmitRequired()
            }
        },
        genderOptions() {
            return player.genderOptions
        },
        playerGender() {
            if (this.player.gender) {
                return this.player.gender
            }
            else {
                return player.genderDefaultValue
            }
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.player.name) {
                    Toast(this.locale['player-name-required'])
                }
                else if (!this.player.num) {
                    Toast(this.locale['player-num-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-player'],
                message: this.locale['delete-player-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete',
                    data: { id: this.player.id, matchGroupId: this.player.matchGroupId }
                })
            }).catch(() => {
                // on cancel
            })
        },
        onLogoUploaderDataChange(data) {
            console.log('onLogoUploaderDataChange', this.isEdit, data)
            this.player.logoUrl = data
        },
        onPlayerNameAutoFocus() {
            return !this.isEdit
        },
        onGenderDataChange(data) {
            if (data.value == this.player.gender) {
                return
            }
            this.player.gender = data.value
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.player.name && this.player.num) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            if (this.validateSubmitRequired()) {
                this.$emit('custom-event', {
                    type: 'save',
                    data: this.player
                })
            }
        }
    },
}
</script>

<template>
    <div class="player-edit">
        <van-form>
            <van-field 
                name="player-name" 
                v-model="player.name" 
                :label="locale['player-name-label']" 
                :placeholder="locale['player-name-placeholder']"
                :autofocus="onPlayerNameAutoFocus"
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="30" 
            />
            <picker-selector
                :label="locale['player-gender-label']"
                :options="genderOptions"
                :value="playerGender"
                @change-data="onGenderDataChange"
            />
            <image-uploader
                :label="locale['player-logo-label']"
                :description="locale['player-logo-placeholder']"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.player.logoUrl, 400, 400)"
                @change-data="onLogoUploaderDataChange"
            />
            <van-field
                v-model="player.num"
                :label="locale['player-num-label']"
                :placeholder="locale['player-num-placeholder']"
                type="digit"
                clearable
                input-align="right"
                maxlength="2"
            />
        </van-form>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>